import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import useIsMemberAuthorized from '@/hooks/useIsMemberAuthorized';
import { getMe, getStatusTelegram } from '@/api/hypertrackerApi';
import { setMe, setTelegramConnectionHT } from '@/state/hypertracker/hypertackerSlice';

const useInitialHypertrackerData = () => {
    const dispatch = useDispatch();
    const isMemberAuthorized = useIsMemberAuthorized();

    const fetchTelegramConnection = async () => {
        try {
            const [telegramConnection, me] = await Promise.all([getStatusTelegram(), getMe()]);

            dispatch(setMe(me.data ?? null));
            dispatch(setTelegramConnectionHT(telegramConnection?.data?.connection || null));
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (isMemberAuthorized) {
            fetchTelegramConnection();
        }
    }, [isMemberAuthorized]);
};

export default useInitialHypertrackerData;
